export function bytesToMB(bytes: number, floatingPoint = 1) {
  return +(bytes / 1_000_000).toFixed(floatingPoint);
}
